// @flow
import * as React from 'react';
import Link from 'gatsby-link';
import { Trans } from '@lingui/react';
import SignupForm from '../components/SignupForm';
import { Logo } from './Logo';
import type { LayoutProps } from './LayoutProps';

export const hasFooter = (pathname: string) => !pathname.match(/contact/);


export const Footer = (props: LayoutProps) => (
  <div>
    {hasFooter(props.location.pathname) &&
    <section className="section bg-pale-secondary" id="try">
      <div className="container text-center signup py-7">
        <h2><Trans>s3_link</Trans></h2>

        <SignupForm {...props} />

        <p>
          <Trans>
            s3_text_more
          </Trans>
        </p>

      </div>
    </section>}
    <footer className="footer py-7">
      <div className="container">
        <div className="row gap-y">

          <div className="col-md-6 col-xl-3">
            <Logo {...props} inverse={false} />
          </div>

          <div className="col-6 col-md-6 col-xl-6">

            <div className="nav flex-column">
              <a href="mailto:admin@huanggangxinyuan.com"><i className="fa fa-envelope" />&nbsp;admin@huanggangxinyuan.com </a>
              <a className="social" href="tel:07138381712"><i className="fa fa-phone" />&nbsp;0713 8381712</a>
              <a className="social-google" target="blank" href="http://map.baidu.com/?newmap=1&s=inf%26uid%3Dcac5fc7639db14f32cb96de1%26wd%3D%E9%BB%84%E5%86%88%E4%BF%A1%E6%BA%90%26all%3D1%26c%3D&from=alamap&tpl=mapdots">
                <i className="fa fa-map-marker" />&nbsp;
                东门路12号
              </a>
            </div>
          </div>

          <div className="col-6 col-md-6 col-xl-2 text-center px-1">
            {props.prefix ?
              <Link href to={props.location.pathname.substr(3)} className="btn btn-round btn-outline-primary">中文</Link> :
              <Link href to={`en${props.location.pathname}`} className="btn btn-round btn-outline-primary">English</Link>}
          </div>

        </div>
      </div>
    </footer>
  </div>);



// WEBPACK FOOTER //
// ./src/layouts/Footer.jsx